import React, { useState, useCallback, useEffect } from 'react';
import { levelViewsData } from './dataLevelViews';

export default function ViewLevelViews({ apartmentType, selectedLevel, isEnlargedOpen, onSelectView }) {
  const views = levelViewsData[apartmentType] || [];
  const [hoveredIdx, setHoveredIdx] = useState(null);

  // Reset hover when apartment type changes
  useEffect(() => {
    setHoveredIdx(null);
  }, [apartmentType]);

  const handleClick = useCallback((view) => {
    onSelectView({
      ...view,
      caption: `${view.label} - Apartment ${view.img.replace('.jpg', '')}`,
    });
  }, [onSelectView]);

  const handleMouseEnter = useCallback((idx) => setHoveredIdx(idx), []);
  const handleMouseLeave = useCallback(() => setHoveredIdx(null), []);

  if (views.length === 0) return null;

  return (
    <div className={`level-views--panel${isEnlargedOpen ? ' level-views--panel-hidden' : ''}`}>
      <div className='level-views--title'>Level Views</div>
      <div className='level-views--divider' />
      <ul className='level-views--list'>
        {views.map((view, idx) => (
          <li key={idx}>
            <button
              className={`level-views--item${hoveredIdx === idx ? ' active' : ''}`}
              onClick={() => handleClick(view)}
              onMouseEnter={() => handleMouseEnter(idx)}
              onMouseLeave={handleMouseLeave}
            >
              <span className='level-views--item-label'>{view.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
